/* eslint-disable no-console */
const axios = require('axios');

export const checkMosaicSCCON = async (year, month) => {

  const yearNum = parseInt(year, 10);
  const monthNum = parseInt(month, 10);
  const paddedMonth = String(monthNum).padStart(2, '0');
  const mosaicName = `global_monthly_${yearNum}_${paddedMonth}_mosaic`;

  const url = 'https://tileserver-pf.sccon.com.br/sccon/basemaps/service';
  const token = '2e7cc51e-6c5a-11ef-b4a4-ef9387ced80b';

  try {
    const response = await axios.get(url, {
      params: {
        token,
        REQUEST: 'GetCapabilities',
      },
    });

    const found = response.data.includes(mosaicName);

    if (found) {
      return { year: yearNum, month: paddedMonth };
    } else {
      let newMonth = monthNum - 1;
      let newYear = yearNum;

      if (newMonth === 0) {
        newMonth = 12;
        newYear -= 1;
      }

      // Limite inferior: julho de 2017
      if (newYear < 2017 || (newYear === 2017 && newMonth < 7)) {
        console.log('Atingido o limite inferior: julho de 2017');
        return { year: year, month: month };
      }

      return checkMosaicSCCON(newYear, newMonth);
    }
  } catch (error) {
    console.error('Erro ao buscar GetCapabilities:', error.message);
    return { year: year, month: month };
  }
};

export default checkMosaicSCCON;
